<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-auto_fetch_form'"
    @cancelled="onCancel"
  >
    <template slot="header">Auto Fetch</template>

    <template slot="body">
      <div class="body-container">
        <Dropdown
          :options="chooseTypesItem"
          :selected="chooseTypesItem.find((e) => e.value == external_table2)"
          :placeholder="'Select Type'"
          deselect
          box
          @selectedChange="(e) => onDropdownType(e)"
        ></Dropdown>

        <Dropdown
          v-if="labelFormFlag"
          :options="labelsTV"
          :selected="labelsTV.find((e) => e.value == external_id2)"
          :placeholder="'Label'"
          box
          v-on:selectedChange="(e) => onDropdownChange(e)"
        ></Dropdown>

        <Dropdown
          v-if="supplierFormFlag"
          :options="suppliersTV"
          :selected="suppliersTV.find((e) => e.value == external_id2)"
          :placeholder="'Supplier'"
          box
          v-on:selectedChange="(e) => onDropdownChange(e)"
        ></Dropdown>
        <DTCheckbox
          v-if="labelFormFlag || supplierFormFlag"
          :id="'separate_contract'"
          :label="$t('exclude_existing')"
          :checked="text02 === '1'"
          @click="onCheckCliked"
          :minH="'42px'"
          :class="'ml0'"
        />
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { createTV } from "../../../../models/text-value.model";
import { ContractsService } from "../../services/contracts.service";

export default {
  components: {
    Modal,
  },
  props: ["selectedContractDetails"],
  data: () => ({
      text02: "0",

      labels: [],
      suppliers: [],

      external_id2: "",
      external_table2: "",

      labelFormFlag: false,
      supplierFormFlag: false,
    }),
  mounted: async function () {
    const res = await ContractsService.autoFetchForm(this.contract_id);
    this.labels = res.data.labels;
    this.suppliers = res.data.suppliers;
  },
  computed: {
    chooseTypesItem: function () {
      return [
        { text: "Label", value: "label" },
        { text: "Supplier", value: "supplier" },
      ];
    },
    labelsTV: function () {
      return createTV(this.labels, "label_name", "label_id");
    },
    suppliersTV: function () {
      return createTV(this.suppliers, "supplier_name", "supplier_id");
    },
    contract_id: function () {
      return this.$route.params.contract_id;
    },
  },
  methods: {
    onDropdownChange(value) {
      if (value) {
        this.external_id2 = value.value;
      }
    },
    resetFlags: function () {
      this.labelFormFlag = false;
      this.supplierFormFlag = false;
    },
    onDropdownType(type) {
      this.external_table2 = type.value;

      if (type.value === "label") {
        this.onLabelClick();
      } else if (type.value === "supplier") {
        this.onSupplierClick();
      }
    },

    onLabelClick: function () {
      this.labelFormFlag = true;
      this.supplierFormFlag = false;
    },

    onSupplierClick: function () {
      this.labelFormFlag = false;
      this.supplierFormFlag = true;
    },

    onOkClick: async function () {
      const res = await ContractsService.submitAutoFetchForm({
        contract_id: this.contract_id,
        external_table2: this.external_table2,
        external_id2: this.external_id2,
        text02: this.text02
      });
      this.$emit("added", res.data);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onCheckCliked: function (event) {
      if (event.target.checked) {
        this.text02 = "1";
      } else {
        this.text02 = "0";
      }
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-auto_fetch_form {
  .dropdown {
    margin-bottom: 10px;
  }
}
</style>
